import { createSystem, defaultConfig } from '@chakra-ui/react';

export const system = createSystem(defaultConfig);

export default system;
